import { render, staticRenderFns } from "./ProjectsIndex.vue?vue&type=template&id=0313f38f"
import script from "./ProjectsIndex.vue?vue&type=script&lang=js"
export * from "./ProjectsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports